import React, { useContext, useEffect, useState } from "react";
import { auth } from "../firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import {db} from '../firebase'
import { doc, getDoc } from "firebase/firestore";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [currentAdmin, setCurrentAdmin] = useState();

  async function signup(email, password) {
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      // return new Promise((resolve, reject) => {
      //   const unsubscribe = auth.onAuthStateChanged(
      //     authenticatedUser => {
      //       if (authenticatedUser) {
      //         resolve(authenticatedUser.uid);
      //       } else {
      //         reject(new Error('User not authenticated.'));
      //       }
      //       unsubscribe(); // Remove the listener once resolved or rejected
      //     },
      //     error => {
      //       reject(error); // Reject with any error during authentication state change
      //       unsubscribe(); // Remove the listener on error as well
      //     }
      //   );
      // });
      sendEmailVerification(user);
      return user;
    } catch (error) {
      throw error;
    }
  }

  async function login(email, password) {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      return user;
    } catch (error) {
      // Handle login errors here if needed
      console.error("Login error:", error);
      throw error; // Re-throw the error for handling at a higher level if needed
    }
  }

  async function adminLogin(email, password) {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      const docRef = doc(db, "admin", user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        const userString = JSON.stringify(user);
        const userDetail = JSON.stringify(docSnap.data());
        sessionStorage.setItem("currentAdmin", userString);
        sessionStorage.setItem("currentAdminDetail", userDetail);
        setIsAdmin(true)
      } else {
        console.log("No such document!", user.uid);
        setIsAdmin(false)
        logout();
        throw new Error(
          "Failed to login. Please make sure you have admin account"
        );
      }
      return user;
    } catch (error) {
      // Handle login errors here if needed
      console.error("Login error:", error);
      throw error; // Re-throw the error for handling at a higher level if needed
    }
  }

  //create login for admin
  //if not found in admin, through error
  //set admin flag = true

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(
      async (user) => {
        console.log("ffdfdf", user);
        const admin =await checkIsAdmin (user)
        //set admin here
        if (user && !admin) {
          console.log('Login As User')
          setCurrentUser(user);
          setCurrentAdmin(null);
          setIsAdmin(false);
          setLoading(false);
        } else if (user && admin) {
          console.log("Login As Admin ", admin)
          setCurrentAdmin(user)
          setLoading(false);
        } else {
          setCurrentAdmin(null);
          setCurrentUser(null);
          setIsAdmin(false);
          setLoading(false);
        }
      },
      (error) => {
        // Handle any errors from the authentication state change
        console.error("Authentication state change error: ", error);
        setLoading(false);
      }
    );
    return unsubscribe;
  }, []);

  async function checkIsAdmin(user){
    try{
          const docRef = doc(db, "admin", user.uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      console.log("Document data:", docSnap.data());
      setIsAdmin(true)
      return true
    } else {
      setIsAdmin(false)
      return false
    }

    }catch (error){
      return false
    }

  }

  function logout() {
    console.log("Logout Clicked");
    sessionStorage.clear();
    setIsAdmin(false);
    return auth.signOut();
  }

  const value = {
    currentUser,
    currentAdmin,
    login,
    signup,
    logout,
    adminLogin,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
